// extracted by mini-css-extract-plugin
export var maxWidth = "HalfBGContentCard-module--max-width--3PQjr";
export var grey = "HalfBGContentCard-module--grey--iSBIK";
export var white = "HalfBGContentCard-module--white--2FqiV";
export var copyLeft = "HalfBGContentCard-module--copy-left--vtg-_";
export var copyRight = "HalfBGContentCard-module--copy-right--24y6o";
export var padTop = "HalfBGContentCard-module--pad-top--19N7A";
export var copyGrid = "HalfBGContentCard-module--copy-grid--2Vj2-";
export var lighten = "HalfBGContentCard-module--lighten--2dgAn";
export var testimonial = "HalfBGContentCard-module--testimonial--qg28N";
export var grid = "HalfBGContentCard-module--grid--2b_hI";
export var sepGrid = "HalfBGContentCard-module--sep-grid--2M1ln";
export var imageBackground = "HalfBGContentCard-module--image-background--3mjtY";
export var imageWrap = "HalfBGContentCard-module--image-wrap--275jz";
export var videoPlayer = "HalfBGContentCard-module--video-player--1HKbG";
export var imageBackgroundGrid = "HalfBGContentCard-module--image-background-grid--2OERV";
export var imageLeft = "HalfBGContentCard-module--image-left--2JSuG";
export var imageRight = "HalfBGContentCard-module--image-right--1uTD8";
export var mainImage = "HalfBGContentCard-module--main-image--2EgVS";
export var halfBackground = "HalfBGContentCard-module--half-background--UBV86";
export var animate = "HalfBGContentCard-module--animate--F5Ksx";
export var visible = "HalfBGContentCard-module--visible--29V2q";